/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** A string backed decimal parser */
  Decimal: { input: any; output: any; }
};

export type AccessGiftIntent = {
  deliverAt: Scalars['String']['output'];
  discountAmount: Currency;
  id: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
  purchaserEmail: Scalars['String']['output'];
  purchaserName: Scalars['String']['output'];
  recipientEmail: Scalars['String']['output'];
  recipientName: Scalars['String']['output'];
  redemptionCode?: Maybe<Scalars['String']['output']>;
  status: GiftingAccessPurchaseStatus;
  stripeClientSecret: Scalars['String']['output'];
  subtotalAmount: Currency;
  taxAmount: Currency;
  totalAmount: Currency;
  troonCardSubscriptionProduct?: Maybe<TroonCardSubscriptionProduct>;
};

export type AccessGiftPurchaseInput = {
  deliverAt: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  purchaserEmail: Scalars['String']['input'];
  purchaserName: Scalars['String']['input'];
  recipientEmail: Scalars['String']['input'];
  recipientName: Scalars['String']['input'];
};

export type Address = {
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  displayString: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
};

export enum Benefit {
  Golfpass = 'GOLFPASS',
  Inkind = 'INKIND'
}

export type BenefitCode = {
  benefit: Benefit;
  code: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type BullJob = {
  attemptsMade: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type BullJobCollection = {
  jobs: Array<BullJob>;
  name: Scalars['String']['output'];
};

export type CalendarDay = {
  day: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type CalendarDayInput = {
  day: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type CalendarDayTime = {
  day: CalendarDay;
  time: CalendarTime;
};

export type CalendarDayTimeInput = {
  day: CalendarDayInput;
  time: CalendarTimeInput;
};

export type CalendarEvent = {
  google: Scalars['String']['output'];
  ics: Scalars['String']['output'];
  office365: Scalars['String']['output'];
  outlook: Scalars['String']['output'];
  yahoo: Scalars['String']['output'];
};

export type CalendarTime = {
  /** 0-23 hour of day */
  hour: Scalars['Int']['output'];
  minute: Scalars['Int']['output'];
  second?: Maybe<Scalars['Int']['output']>;
};

export type CalendarTimeInput = {
  /** 0-23 hour of day */
  hour: Scalars['Int']['input'];
  minute: Scalars['Int']['input'];
  second?: InputMaybe<Scalars['Int']['input']>;
};

export type ChangePasswordInput = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};

export type ConfirmPhoneNumberInput = {
  confirmationCode: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type ConfirmUpdateEmailInput = {
  confirmationCode: Scalars['String']['input'];
  newEmail: Scalars['String']['input'];
};

export type Coordinates = {
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type CoordinatesInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type Course = {
  adminOnly: Scalars['Boolean']['output'];
  bookingWindowDay: CalendarDay;
  bookingWindowInDays: Scalars['Int']['output'];
  canCancelTeeTimes: Scalars['Boolean']['output'];
  checkInEnabled: Scalars['Boolean']['output'];
  closures: Array<CourseClosure>;
  facility?: Maybe<CourseFacility>;
  facilityId?: Maybe<Scalars['String']['output']>;
  facilityName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isBookable: Scalars['Boolean']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  metadata?: Maybe<CourseMetadata>;
  name: Scalars['String']['output'];
  requiresCCAtBooking: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  supportsTeeTimeAlerts: Scalars['Boolean']['output'];
  supportsTroonAccess: Scalars['Boolean']['output'];
  supportsTroonRewards: Scalars['Boolean']['output'];
};

export type CourseClosure = {
  courseId: Scalars['String']['output'];
  endDay: CalendarDay;
  id: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  startDay: CalendarDay;
};

export type CourseFacility = {
  adminOnly: Scalars['Boolean']['output'];
  brand: FacilityBrand;
  createdAt: Scalars['String']['output'];
  displayConfig: Array<FacilityDisplayConfig>;
  id: Scalars['String']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isBookable: Scalars['Boolean']['output'];
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isFeatured: Scalars['Boolean']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  metadata?: Maybe<FacilityMetadata>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  supportsAccessPoints: Scalars['Boolean']['output'];
  supportsAccessRewards: Scalars['Boolean']['output'];
  supportsHotDeals: Scalars['Boolean']['output'];
  supportsTroonAccess: Scalars['Boolean']['output'];
  supportsTroonAccessCourseSiteUpsell: Scalars['Boolean']['output'];
  supportsTroonAccessPrive: Scalars['Boolean']['output'];
  supportsTroonAdvantage: Scalars['Boolean']['output'];
  supportsTroonRewards: Scalars['Boolean']['output'];
  timezone: Scalars['String']['output'];
  troonFacilityId: Scalars['String']['output'];
  type: FacilityType;
  updatedAt: Scalars['String']['output'];
};

/** This is deprecated, Use facility.metadata instead */
export type CourseMetadata = {
  address?: Maybe<Address>;
  description?: Maybe<Scalars['String']['output']>;
  hero?: Maybe<Media>;
  logo?: Maybe<Media>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type CourseRewardRedemptionEntry = {
  courseName: Scalars['String']['output'];
  months: Array<FacilityRewardRedemptionEntryMonth>;
};

export type CourseTeeTime = {
  /** @deprecated Use troonSubscriptionRates instead */
  accessCardRate?: Maybe<CourseTeeTimeRate>;
  cartIncluded: Scalars['Boolean']['output'];
  course: Course;
  courseId: Scalars['String']['output'];
  dayTime: CalendarDayTime;
  hasAccessPlusDeal: Scalars['Boolean']['output'];
  holesOption: RoundHolesOption;
  id: Scalars['String']['output'];
  maxPlayers: Scalars['Int']['output'];
  maxPrice: Currency;
  minPlayers: Scalars['Int']['output'];
  minPrice: Currency;
  practiceBallsIncluded: Scalars['Boolean']['output'];
  publicRate?: Maybe<CourseTeeTimeRate>;
  rates: Array<CourseTeeTimeRate>;
  /** @deprecated Use troonSubscriptionRates instead */
  signatureCardRate?: Maybe<CourseTeeTimeRate>;
  troonAccessPlusRate?: Maybe<CourseTeeTimeRate>;
  troonAccessRate?: Maybe<CourseTeeTimeRate>;
  troonSubscriptionRates: Array<CourseTeeTimeRate>;
};

export type CourseTeeTimeAlertTriggerTeeTimePreview = {
  hasMore: Scalars['Boolean']['output'];
  teeTimes: Array<CourseTeeTime>;
};

export type CourseTeeTimeCancellationInfo = {
  cancellationFee: Currency;
  cancellationThresholdInHours: Scalars['Int']['output'];
  displayMessage: Scalars['String']['output'];
  isCancellable: Scalars['Boolean']['output'];
};

export type CourseTeeTimeFilters = {
  endAt?: InputMaybe<CalendarTimeInput>;
  group?: InputMaybe<Scalars['String']['input']>;
  hotDeals?: InputMaybe<Scalars['Boolean']['input']>;
  includeCart?: InputMaybe<Scalars['Boolean']['input']>;
  players?: InputMaybe<Scalars['Int']['input']>;
  startAt?: InputMaybe<CalendarTimeInput>;
  troonAccessPlusDeal?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CourseTeeTimePaymentInfo = {
  paymentProcessor: PaymentProcessor;
  receipt: Receipt;
  requiresCreditCard: Scalars['Boolean']['output'];
  rewardPointsEarned: Scalars['Int']['output'];
  rewardPointsUsed: Scalars['Int']['output'];
};

export type CourseTeeTimeRate = {
  appliesToAllUsers: Scalars['Boolean']['output'];
  cartIncluded: Scalars['Boolean']['output'];
  dayTime: CalendarDayTime;
  description?: Maybe<Scalars['String']['output']>;
  holesOption: RoundHolesOption;
  id: Scalars['String']['output'];
  isAvailableToUser: Scalars['Boolean']['output'];
  isBookable: Scalars['Boolean']['output'];
  isLocalCardRate: Scalars['Boolean']['output'];
  /** This means it's the old troon card rate */
  isOldTroonCardRate: Scalars['Boolean']['output'];
  isPrePaid: Scalars['Boolean']['output'];
  isPublicRate: Scalars['Boolean']['output'];
  isTroonAccessPlusRate: Scalars['Boolean']['output'];
  isTroonAccessRate: Scalars['Boolean']['output'];
  /** This means it's access or access plus. Just using old terminology */
  isTroonCardRate: Scalars['Boolean']['output'];
  isViewable: Scalars['Boolean']['output'];
  maxPlayers: Scalars['Int']['output'];
  minPlayers: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  overridePrice?: Maybe<Currency>;
  practiceBallsIncluded: Scalars['Boolean']['output'];
  price: Currency;
  rackPrice: Currency;
  teeSheetPrice: Currency;
};

export type CourseTeeTimeReservationInfo = {
  availableRates: Array<CourseTeeTimeRate>;
  cancellationInfo: CourseTeeTimeCancellationInfo;
  course: Course;
  courseNotes?: Maybe<Scalars['String']['output']>;
  facility: Facility;
  holes: RoundHolesOption;
  paymentInfo: CourseTeeTimePaymentInfo;
  players: Scalars['Int']['output'];
  rate: CourseTeeTimeRate;
  reserveId: Scalars['String']['output'];
  teeTime: CourseTeeTime;
  troonSubscriptionRate?: Maybe<CourseTeeTimeRate>;
  troonSubscriptionRateDiscounts: TroonSubscriptionRateDiscounts;
  /** This will only be non null if the current user has a troonSubscriptionRate and there is a cheaper rate for an upgraded subscription plan */
  troonSubscriptionUpgradeRate?: Maybe<CourseTeeTimeRate>;
};

export type CreateFacilityTeeTimeAlertTriggerInput = {
  courseIds: Array<Scalars['String']['input']>;
  day: CalendarDayInput;
  emailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  endAt?: InputMaybe<CalendarTimeInput>;
  players?: InputMaybe<Scalars['Int']['input']>;
  pushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  smsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  startAt?: InputMaybe<CalendarTimeInput>;
};

export type CreditCard = {
  brand: CreditCardBrand;
  id: Scalars['String']['output'];
  lastFour: Scalars['String']['output'];
  paymentProcessor: PaymentProcessor;
};

export enum CreditCardBrand {
  Amex = 'AMEX',
  Discover = 'DISCOVER',
  Mastercard = 'MASTERCARD',
  Other = 'OTHER',
  Visa = 'VISA'
}

export type Currency = {
  cents?: Maybe<Scalars['Int']['output']>;
  code: CurrencyCode;
  displayValue: Scalars['String']['output'];
  value: Scalars['Decimal']['output'];
};

export enum CurrencyCode {
  Aed = 'AED',
  Aud = 'AUD',
  Azn = 'AZN',
  Bgn = 'BGN',
  Bhd = 'BHD',
  Bsd = 'BSD',
  Cad = 'CAD',
  Chf = 'CHF',
  Crc = 'CRC',
  Czk = 'CZK',
  Egp = 'EGP',
  Eur = 'EUR',
  Gbp = 'GBP',
  Hnl = 'HNL',
  Inr = 'INR',
  Jod = 'JOD',
  Khr = 'KHR',
  Krw = 'KRW',
  Lkr = 'LKR',
  Mad = 'MAD',
  Mxn = 'MXN',
  Myr = 'MYR',
  Nok = 'NOK',
  Omr = 'OMR',
  Pab = 'PAB',
  Sar = 'SAR',
  Twd = 'TWD',
  Usd = 'USD'
}

export type DeactivateGuestPassResponse = {
  guestPass: GuestPass;
  reservation: Reservation;
};

export type DeleteUser = {
  success: Scalars['Boolean']['output'];
};

export type Destination = DestinationPlace | DestinationRegion;

export type DestinationPlace = {
  place: Place;
};

export type DestinationRegion = {
  region: Region;
};

export enum DeviceLocationStatus {
  AllowedWhenOpen = 'ALLOWED_WHEN_OPEN',
  AlwaysAllowed = 'ALWAYS_ALLOWED',
  Denied = 'DENIED',
  NotDetermined = 'NOT_DETERMINED'
}

export enum DevicePushStatus {
  Denied = 'DENIED',
  Granted = 'GRANTED',
  NotDetermined = 'NOT_DETERMINED'
}

export enum DeviceType {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

export type EmptyResponse = {
  ok: Scalars['Boolean']['output'];
};

export type EzlinkMembership = {
  contactMembershipId?: Maybe<Scalars['String']['output']>;
  membershipEndDate?: Maybe<Scalars['String']['output']>;
  membershipId: Scalars['String']['output'];
  membershipStartDate?: Maybe<Scalars['String']['output']>;
  membershipType?: Maybe<Scalars['String']['output']>;
};

export type FacilitiesResponse = {
  cursor?: Maybe<Scalars['String']['output']>;
  facilities: Array<Facility>;
  totalCount: Scalars['Int']['output'];
};

export type Facility = {
  adminOnly: Scalars['Boolean']['output'];
  brand: FacilityBrand;
  courses: Array<Course>;
  createdAt: Scalars['String']['output'];
  displayConfig: Array<FacilityDisplayConfig>;
  id: Scalars['String']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isBookable: Scalars['Boolean']['output'];
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isFeatured: Scalars['Boolean']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  metadata?: Maybe<FacilityMetadata>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  supportsAccessPoints: Scalars['Boolean']['output'];
  supportsAccessRewards: Scalars['Boolean']['output'];
  supportsHotDeals: Scalars['Boolean']['output'];
  supportsTroonAccess: Scalars['Boolean']['output'];
  supportsTroonAccessCourseSiteUpsell: Scalars['Boolean']['output'];
  supportsTroonAccessPrive: Scalars['Boolean']['output'];
  supportsTroonAdvantage: Scalars['Boolean']['output'];
  supportsTroonRewards: Scalars['Boolean']['output'];
  timezone: Scalars['String']['output'];
  troonFacilityId: Scalars['String']['output'];
  type: FacilityType;
  updatedAt: Scalars['String']['output'];
};

export enum FacilityBrand {
  Icon = 'ICON',
  IndigoSports = 'INDIGO_SPORTS',
  None = 'NONE',
  ObSports = 'OB_SPORTS',
  TroonGolf = 'TROON_GOLF',
  TroonGolfIntl = 'TROON_GOLF_INTL',
  TroonPartner = 'TROON_PARTNER',
  TroonPrive = 'TROON_PRIVE',
  TroonPriveIntl = 'TROON_PRIVE_INTL'
}

export type FacilityClosure = {
  courses: Array<Course>;
  endDay: CalendarDay;
  id: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  startDay: CalendarDay;
};

export enum FacilityDisplayConfig {
  AccessFilter = 'ACCESS_FILTER',
  FeaturedAccessOffers = 'FEATURED_ACCESS_OFFERS',
  GolfnowOfferFilter = 'GOLFNOW_OFFER_FILTER',
  GolfnowOfferRates = 'GOLFNOW_OFFER_RATES',
  InlineAccessOffers = 'INLINE_ACCESS_OFFERS',
  InlineAccessUpsell = 'INLINE_ACCESS_UPSELL',
  ReserveAccessRate = 'RESERVE_ACCESS_RATE'
}

export type FacilityLocationInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  radiusMiles?: InputMaybe<Scalars['Float']['input']>;
};

export type FacilityMedia = {
  type?: Maybe<FacilityMediaType>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum FacilityMediaType {
  Gallery = 'GALLERY',
  Hero = 'HERO',
  Logo = 'LOGO',
  Video = 'VIDEO',
  VideoThumb = 'VIDEO_THUMB'
}

export type FacilityMetadata = {
  address?: Maybe<Address>;
  caddieMaster: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dining: Scalars['Boolean']['output'];
  fitness: Scalars['Boolean']['output'];
  gallery: Array<FacilityMedia>;
  hero?: Maybe<FacilityMedia>;
  heroId?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<FacilityMedia>;
  logoId?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  spa: Scalars['Boolean']['output'];
  swimming: Scalars['Boolean']['output'];
  tennis: Scalars['Boolean']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type FacilityNote = {
  endDay: CalendarDay;
  id: Scalars['String']['output'];
  note: Scalars['String']['output'];
  startDay: CalendarDay;
};

export type FacilityRedirect = {
  redirectUrl: Scalars['String']['output'];
  variation: Scalars['String']['output'];
};

export type FacilityRewardRedemptionEntry = {
  courses: Array<CourseRewardRedemptionEntry>;
  facilityId: Scalars['String']['output'];
  facilityName: Scalars['String']['output'];
  facilitySlug: Scalars['String']['output'];
  location: Scalars['String']['output'];
  months: Array<FacilityRewardRedemptionEntryMonth>;
  regionName: Scalars['String']['output'];
};

export type FacilityRewardRedemptionEntryMonth = {
  freePoints?: Maybe<Scalars['Int']['output']>;
  halfOffPoints?: Maybe<Scalars['Int']['output']>;
  halfOffPrice?: Maybe<Currency>;
  month: Scalars['Int']['output'];
};

export type FacilityRewardRedemptionRegion = {
  entries: Array<FacilityRewardRedemptionEntry>;
  regionName: Scalars['String']['output'];
};

export enum FacilitySortField {
  Cursor = 'cursor',
  Name = 'name'
}

export type FacilityTeeTimeAlertTrigger = {
  courseIds: Array<Scalars['String']['output']>;
  courseTeeTimesPreview: CourseTeeTimeAlertTriggerTeeTimePreview;
  day: CalendarDay;
  endAt?: Maybe<CalendarTime>;
  facility: Facility;
  facilityId: Scalars['String']['output'];
  players?: Maybe<Scalars['Int']['output']>;
  startAt?: Maybe<CalendarTime>;
  state: TeeTimeAlertState;
};


export type FacilityTeeTimeAlertTriggerCourseTeeTimesPreviewArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  troonCardSubscriptionRates?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum FacilityType {
  DailyFeeResort = 'DAILY_FEE_RESORT',
  Hospitality = 'HOSPITALITY',
  Private = 'PRIVATE',
  Residential = 'RESIDENTIAL',
  SemiPrivate = 'SEMI_PRIVATE'
}

export type FailedBullJobs = {
  failed: Array<BullJobCollection>;
};

export enum GiftingAccessPurchaseStatus {
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Pending = 'PENDING'
}

export type GuestPass = {
  guestDiscount?: Maybe<Currency>;
  guestUser?: Maybe<User>;
  guestUserId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  reservation?: Maybe<Reservation>;
  reservationId?: Maybe<Scalars['String']['output']>;
  reservationUser?: Maybe<ReservationUser>;
  reservationUserId?: Maybe<Scalars['String']['output']>;
  shareInviteUrl?: Maybe<Scalars['String']['output']>;
  status: GuestPassStatus;
  user: User;
  userId: Scalars['String']['output'];
};

export enum GuestPassStatus {
  Accepted = 'ACCEPTED',
  Available = 'AVAILABLE',
  Cancelled = 'CANCELLED',
  Pending = 'PENDING'
}

export type Location = {
  country: Scalars['String']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  place: Scalars['String']['output'];
  region: Scalars['String']['output'];
};

export type Login = {
  accessToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  user: User;
};

export type LoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  syncInBackground?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Logout = {
  success: Scalars['Boolean']['output'];
};

export type MacroRegion = {
  facilityCount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  troonAccessFacilityCount: Scalars['Int']['output'];
};

export type Media = {
  url?: Maybe<Scalars['String']['output']>;
};

export type MergeUserAccount = {
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  rewardsId: Scalars['String']['output'];
  rewardsLevel: UserRewardsLevel;
  rewardsPoints: Scalars['Int']['output'];
  troonAccessProductType?: Maybe<TroonCardSubscriptionProductType>;
};

export type MergeUserAccountInput = {
  aRewardsId: Scalars['String']['input'];
  bRewardsId: Scalars['String']['input'];
  finalEmail: Scalars['String']['input'];
  finalRewardsId: Scalars['String']['input'];
};

export type MergeUserAccountResponse = {
  userA: MergeUserAccount;
  userB: MergeUserAccount;
};

export type Mutation = {
  acceptReservationInvite: Reservation;
  addCreditCard: CreditCard;
  addGuestPassToUser: Reservation;
  addStripeCreditCard: CreditCard;
  cancelReservation: Reservation;
  cancelTroonCardSubscription: TroonCardSubscription;
  changePassword: EmptyResponse;
  checkInToReservation: Reservation;
  claimBenefitCode: BenefitCode;
  confirmAccessGiftPurchaseIntent: AccessGiftIntent;
  confirmEmailMagicLink: Login;
  confirmPhoneNumber: User;
  confirmTroonCardSubscriptionPayment: TroonCardSubscription;
  confirmUpdateEmail: User;
  createFacilityTeeTimeAlert: TeeTimeAlert;
  createOrUpdateAccessGiftPurchaseIntent: AccessGiftIntent;
  createPaymentToken: PaymentToken;
  createStripeSetupIntent: PaymentSetupIntent;
  createSupportRequest: EmptyResponse;
  deactivateGuestPass: DeactivateGuestPassResponse;
  deleteTeeTimeAlert: TeeTimeAlert;
  destroyUser: DeleteUser;
  emailMagicLink: EmptyResponse;
  finalizeCheckIn: ReservationCheckInResponse;
  forgotPassword: ResetPassword;
  inviteUserToReservation: Reservation;
  joinReservation: Reservation;
  leaveReservation: EmptyResponse;
  login: Login;
  loginV2: Login;
  logout: Logout;
  persistFacilityRedirect: FacilityRedirect;
  queueReservationRewards: EmptyResponse;
  refreshTokens: RefreshToken;
  rejectReservationInvite: EmptyResponse;
  removeCreditCard: EmptyResponse;
  removeUserFromReservation: Reservation;
  requestFacility: EmptyResponse;
  reserveTeeTime: Reservation;
  resetPassword: ResetPasswordConfirmDto;
  resubscribeEzlinksXtreamFacility: EmptyResponse;
  retoolAddExtraEzlinksSponsor: EmptyResponse;
  retoolAttachExtraEzlinksSponsorToCourse: EmptyResponse;
  retoolClaimGuestPass: EmptyResponse;
  retoolClearGuestPass: EmptyResponse;
  retoolCreateGuestPass: EmptyResponse;
  retoolDeleteExtraEzlinksSponsor: EmptyResponse;
  retoolDeleteExtraEzlinksSponsorFromCourse: EmptyResponse;
  retoolDeleteGuestPass: EmptyResponse;
  retoolMergeUserAccounts: MergeUserAccount;
  retoolRefreshLightspeedTokens: RetoolLightSpeedInfo;
  retoolReinitializeXtream: EmptyResponse;
  retoolResyncUser: User;
  retoolUpdateLightspeedTokens: RetoolLightSpeedInfo;
  retryAllFailedJobs: RetriedJobsResponse;
  retryFailedJobs: RetriedJobsResponse;
  sendTestPush: EmptyResponse;
  setupTroonCardSubscription: TroonCardSubscriptionIntent;
  signWaiver: UserWaiver;
  signup: SignUp;
  signupV2: SignUp;
  startCheckIn: ReservationPaymentInfo;
  toggleFavoriteFacility: Facility;
  toggleTeeTimeAlert: TeeTimeAlert;
  trackUserAlert: EmptyResponse;
  troonPriveRequest: EmptyResponse;
  updateDevice: EmptyResponse;
  updateEmail: EmptyResponse;
  updateFacilityTeeTimeAlert: TeeTimeAlert;
  updateName: User;
  updatePhoneNumber: EmptyResponse;
  updatePhoneNumberV2: UpdatePhoneNumberResponse;
  updateUser: User;
  updateUserSettings: UserSettings;
  updateZipCode: User;
};


export type MutationAcceptReservationInviteArgs = {
  reservationUserId: Scalars['String']['input'];
};


export type MutationAddCreditCardArgs = {
  brand: CreditCardBrand;
  expirationMonth?: InputMaybe<Scalars['Int']['input']>;
  expirationYear?: InputMaybe<Scalars['Int']['input']>;
  lastFour: Scalars['String']['input'];
  paymentProcessor?: InputMaybe<PaymentProcessor>;
  token: Scalars['String']['input'];
};


export type MutationAddGuestPassToUserArgs = {
  reservationUserId: Scalars['String']['input'];
};


export type MutationAddStripeCreditCardArgs = {
  brand: CreditCardBrand;
  clientSecret: Scalars['String']['input'];
  expirationMonth?: InputMaybe<Scalars['Int']['input']>;
  expirationYear?: InputMaybe<Scalars['Int']['input']>;
  lastFour: Scalars['String']['input'];
  paymentMethodId: Scalars['String']['input'];
};


export type MutationCancelReservationArgs = {
  id: Scalars['String']['input'];
};


export type MutationCancelTroonCardSubscriptionArgs = {
  troonCardSubscriptionId: Scalars['String']['input'];
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationCheckInToReservationArgs = {
  creditCardId: Scalars['String']['input'];
  reservationId: Scalars['String']['input'];
  rewardType?: InputMaybe<RedeemableRewardType>;
};


export type MutationClaimBenefitCodeArgs = {
  benefit: Benefit;
};


export type MutationConfirmAccessGiftPurchaseIntentArgs = {
  id: Scalars['String']['input'];
};


export type MutationConfirmEmailMagicLinkArgs = {
  confirmationCode: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


export type MutationConfirmPhoneNumberArgs = {
  input: ConfirmPhoneNumberInput;
};


export type MutationConfirmTroonCardSubscriptionPaymentArgs = {
  troonCardSubscriptionId: Scalars['String']['input'];
};


export type MutationConfirmUpdateEmailArgs = {
  input: ConfirmUpdateEmailInput;
};


export type MutationCreateFacilityTeeTimeAlertArgs = {
  input: CreateFacilityTeeTimeAlertTriggerInput;
};


export type MutationCreateOrUpdateAccessGiftPurchaseIntentArgs = {
  giftParams: AccessGiftPurchaseInput;
  id?: InputMaybe<Scalars['String']['input']>;
  troonCardSubscriptionProductId?: InputMaybe<Scalars['String']['input']>;
  utmAttributes?: InputMaybe<UtmAttributesInput>;
};


export type MutationCreateSupportRequestArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeactivateGuestPassArgs = {
  guestPassId: Scalars['String']['input'];
};


export type MutationDeleteTeeTimeAlertArgs = {
  alertId: Scalars['String']['input'];
};


export type MutationEmailMagicLinkArgs = {
  email: Scalars['String']['input'];
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationFinalizeCheckInArgs = {
  creditCardId: Scalars['String']['input'];
  reservationId: Scalars['String']['input'];
  rewardType?: InputMaybe<RedeemableRewardType>;
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationInviteUserToReservationArgs = {
  reservationUserId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationJoinReservationArgs = {
  reservationId: Scalars['String']['input'];
  shareInviteId: Scalars['String']['input'];
};


export type MutationLeaveReservationArgs = {
  reservationUserId: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationLoginV2Args = {
  input: LoginInput;
};


export type MutationLogoutArgs = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  deviceType?: InputMaybe<DeviceType>;
};


export type MutationPersistFacilityRedirectArgs = {
  facilitySlug: Scalars['String']['input'];
  urlVariant?: InputMaybe<Scalars['String']['input']>;
  variation: Scalars['String']['input'];
};


export type MutationQueueReservationRewardsArgs = {
  day: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type MutationRefreshTokensArgs = {
  input: RefreshTokenInput;
};


export type MutationRejectReservationInviteArgs = {
  reservationUserId: Scalars['String']['input'];
};


export type MutationRemoveCreditCardArgs = {
  cardId: Scalars['String']['input'];
};


export type MutationRemoveUserFromReservationArgs = {
  reservationUserId: Scalars['String']['input'];
};


export type MutationRequestFacilityArgs = {
  facilityId: Scalars['String']['input'];
};


export type MutationReserveTeeTimeArgs = {
  creditCardId?: InputMaybe<Scalars['String']['input']>;
  reserveId: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  teeTimeAlertTriggerId?: InputMaybe<Scalars['String']['input']>;
  utmAttributes?: InputMaybe<UtmAttributesInput>;
};


export type MutationResetPasswordArgs = {
  confirmationCode: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationResubscribeEzlinksXtreamFacilityArgs = {
  facilityId: Scalars['String']['input'];
};


export type MutationRetoolAddExtraEzlinksSponsorArgs = {
  input: RetoolAddExtraEzlinksSponsorInput;
};


export type MutationRetoolAttachExtraEzlinksSponsorToCourseArgs = {
  input: RetoolAttachExtraEzlinksSponsorToCourseInput;
};


export type MutationRetoolClaimGuestPassArgs = {
  input: RetoolClaimGuestPassInput;
};


export type MutationRetoolClearGuestPassArgs = {
  guestPassId: Scalars['String']['input'];
};


export type MutationRetoolCreateGuestPassArgs = {
  userId: Scalars['String']['input'];
};


export type MutationRetoolDeleteExtraEzlinksSponsorArgs = {
  sponsorId: Scalars['Int']['input'];
};


export type MutationRetoolDeleteExtraEzlinksSponsorFromCourseArgs = {
  input: RetoolDeleteExtraEzlinksSponsorFromCourseInput;
};


export type MutationRetoolDeleteGuestPassArgs = {
  guestPassId: Scalars['String']['input'];
};


export type MutationRetoolMergeUserAccountsArgs = {
  input: MergeUserAccountInput;
};


export type MutationRetoolResyncUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationRetoolUpdateLightspeedTokensArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationRetryAllFailedJobsArgs = {
  name: Scalars['String']['input'];
};


export type MutationRetryFailedJobsArgs = {
  id: Scalars['String']['input'];
};


export type MutationSendTestPushArgs = {
  userId: Scalars['String']['input'];
};


export type MutationSetupTroonCardSubscriptionArgs = {
  promoCode?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  troonCardAssociateInfo?: InputMaybe<TroonCardAssociateInfoDto>;
  troonCardSubscriptionProductId: Scalars['String']['input'];
  utmAttributes?: InputMaybe<UtmAttributesInput>;
};


export type MutationSignupArgs = {
  input: SignUpInput;
};


export type MutationSignupV2Args = {
  input: SignUpInput;
};


export type MutationStartCheckInArgs = {
  reservationId: Scalars['String']['input'];
  rewardType?: InputMaybe<RedeemableRewardType>;
};


export type MutationToggleFavoriteFacilityArgs = {
  facilityId: Scalars['String']['input'];
  isFavorite: Scalars['Boolean']['input'];
};


export type MutationToggleTeeTimeAlertArgs = {
  alertId: Scalars['String']['input'];
};


export type MutationTrackUserAlertArgs = {
  alertId: Scalars['String']['input'];
  neverShow?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationTroonPriveRequestArgs = {
  comments?: InputMaybe<Scalars['String']['input']>;
  dayTime: CalendarDayTimeInput;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  guests?: InputMaybe<Array<Scalars['String']['input']>>;
  homeFacilityId: Scalars['String']['input'];
  homeMembershipNumber: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  members?: InputMaybe<Array<Scalars['String']['input']>>;
  phone: Scalars['String']['input'];
  requestedFacilityId: Scalars['String']['input'];
};


export type MutationUpdateDeviceArgs = {
  apnsToken?: InputMaybe<Scalars['String']['input']>;
  deviceId: Scalars['String']['input'];
  deviceType: DeviceType;
  fcmToken?: InputMaybe<Scalars['String']['input']>;
  locationStatus?: InputMaybe<DeviceLocationStatus>;
  pushStatus?: InputMaybe<DevicePushStatus>;
};


export type MutationUpdateEmailArgs = {
  input: UpdateEmailInput;
};


export type MutationUpdateFacilityTeeTimeAlertArgs = {
  input: UpdateFacilityTeeTimeAlertInput;
};


export type MutationUpdateNameArgs = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};


export type MutationUpdatePhoneNumberArgs = {
  input: UpdatePhoneNumberInput;
};


export type MutationUpdatePhoneNumberV2Args = {
  input: UpdatePhoneNumberInput;
};


export type MutationUpdateUserArgs = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserSettingsArgs = {
  pushNotificationsEnabled: Scalars['Boolean']['input'];
};


export type MutationUpdateZipCodeArgs = {
  zipcode: Scalars['String']['input'];
};

export type NearbyFacilitiesResponse = {
  facilities: Array<NearbyFacility>;
};

export type NearbyFacility = {
  distanceInMiles: Scalars['Float']['output'];
  facility: Facility;
};

export enum NotRedeemableReason {
  NotEnoughPoints = 'NotEnoughPoints',
  NotRedeemableTeeTime = 'NotRedeemableTeeTime'
}

export type OldTroonCardGroup = {
  cardIds: Array<Scalars['String']['output']>;
  combinedName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum PaymentProcessor {
  Golfnow = 'GOLFNOW',
  Stripe = 'STRIPE'
}

export type PaymentSetupIntent = {
  clientSecret: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
};

export type PaymentToken = {
  token: Scalars['String']['output'];
  tokenTypeId: Scalars['Int']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type Place = {
  coordinates: Coordinates;
  countryName: Scalars['String']['output'];
  facilityCount?: Maybe<Scalars['Int']['output']>;
  hero?: Maybe<Media>;
  heroMediaId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  regionName: Scalars['String']['output'];
  troonAccessFacilityCount?: Maybe<Scalars['Int']['output']>;
};

export enum ProgramSignUpType {
  VillageCamelback = 'VILLAGE_CAMELBACK',
  VillageDcRanch = 'VILLAGE_DC_RANCH',
  VillageGainey = 'VILLAGE_GAINEY',
  VillageOcotillo = 'VILLAGE_OCOTILLO'
}

export type Query = {
  accessGiftPurchaseByRedemptionCode: AccessGiftIntent;
  activeTroonCardSubscription?: Maybe<TroonCardSubscription>;
  allFailedJobs: FailedBullJobs;
  allReservations: Array<Reservation>;
  associateTroonAccessInfo: TroonCardAssociateResponseDto;
  availableCourses: Array<Course>;
  checkInEligibility: ReservationCheckInEligibility;
  course: Course;
  courseTeeTimeReservationInfo: CourseTeeTimeReservationInfo;
  courseTeeTimes: Array<CourseTeeTime>;
  courses: Array<Course>;
  creditCards: Array<CreditCard>;
  facilities: Array<Facility>;
  facilitiesV2: FacilitiesResponse;
  facilitiesV3: FacilitiesResponse;
  facility: Facility;
  facilityClosures: Array<FacilityClosure>;
  facilityNotes: Array<FacilityNote>;
  facilityRedirect: FacilityRedirect;
  facilityRewardRedemptionChart?: Maybe<FacilityRewardRedemptionEntry>;
  favoriteCourses: Array<Course>;
  favoriteFacilities: Array<Facility>;
  featuredDestinations: Array<Destination>;
  getClaimedBenefitCodes: Array<BenefitCode>;
  guestPass: GuestPass;
  guestPasses: UserGuestPasses;
  historicalTroonAccessSavings?: Maybe<TroonAccessAggregatedSavings>;
  macroRegions: Array<MacroRegion>;
  me: User;
  nearbyCourses: Array<Course>;
  nearbyFacilities: NearbyFacilitiesResponse;
  nextUpcomingReservations: UpcomingReservations;
  reservation: Reservation;
  reservationInvite: Reservation;
  reservationInvites: Array<Reservation>;
  reservationPaymentInfo: ReservationPaymentInfo;
  reservationRedeemableRewards: Array<RedeemableReward>;
  reservations: Array<Reservation>;
  retoolGetActiveTroonCardSubscriptionByEmail: TroonCardSubscription;
  retoolGetMergeUserAccounts: MergeUserAccountResponse;
  retoolLightspeedInfo: RetoolLightSpeedInfo;
  retoolUserInfo: RetoolUserInfo;
  rewardRedemptionChart: RewardRedemptionChartDto;
  search: SearchResponse;
  searchCourses: Array<Course>;
  searchFacilities: Array<Facility>;
  searchFacilitiesV2: SearchFacilitiesResponse;
  searchUsers: Array<User>;
  suggestedReservationUsers: Array<User>;
  teeTimeAlert: TeeTimeAlert;
  teeTimeAlerts: Array<TeeTimeAlert>;
  testDelay: EmptyResponse;
  troonAccessDiscountsFeed: Array<TroonAccessReservationSavings>;
  troonAccessReservationUpsell?: Maybe<TroonAccessReservationUpsell>;
  troonAccessTeeTimeDealsByCourse: Array<TroonAccessTeeTimeDealByCourse>;
  troonAccessTotalSavings?: Maybe<TroonAccessTotalSavings>;
  troonCardSubscription: TroonCardSubscription;
  troonCardSubscriptionProduct: TroonCardSubscriptionProduct;
  troonCardSubscriptionProducts: Array<TroonCardSubscriptionProduct>;
  troonCardSubscriptions: Array<TroonCardSubscription>;
  upcomingTroonAccessSavings?: Maybe<TroonAccessAggregatedSavings>;
  user: User;
  userExists: UserExists;
  userRewardTransactions: Array<UserRewardTransaction>;
  userRewards: UserRewards;
  userSettings: UserSettings;
  userWaiver?: Maybe<UserWaiver>;
  zipcodeFacilities: Array<Facility>;
};


export type QueryAccessGiftPurchaseByRedemptionCodeArgs = {
  redemptionCode: Scalars['String']['input'];
};


export type QueryActiveTroonCardSubscriptionArgs = {
  includeManagementUrls?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAllReservationsArgs = {
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  past?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: SortOrder;
  upcoming?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAssociateTroonAccessInfoArgs = {
  troonCardSubscriptionId: Scalars['String']['input'];
};


export type QueryAvailableCoursesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCheckInEligibilityArgs = {
  reservationId: Scalars['String']['input'];
};


export type QueryCourseArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  idOrSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCourseTeeTimeReservationInfoArgs = {
  players?: InputMaybe<Scalars['Int']['input']>;
  rateId?: InputMaybe<Scalars['String']['input']>;
  rewardType?: InputMaybe<RedeemableRewardType>;
  teeTimeId: Scalars['String']['input'];
  troonCardSubscriptionRates?: InputMaybe<Scalars['Boolean']['input']>;
  utmAttributes?: InputMaybe<UtmAttributesInput>;
};


export type QueryCourseTeeTimesArgs = {
  courseIds?: InputMaybe<Array<Scalars['String']['input']>>;
  day: CalendarDayInput;
  facilityId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<CourseTeeTimeFilters>;
  troonCardSubscriptionRates?: InputMaybe<Scalars['Boolean']['input']>;
  utmAttributes?: InputMaybe<UtmAttributesInput>;
};


export type QueryCoursesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFacilitiesArgs = {
  cardGroupId?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  stateId?: InputMaybe<Scalars['String']['input']>;
  supportsTroonAccess?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFacilitiesV2Args = {
  cardGroupId?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  stateId?: InputMaybe<Scalars['String']['input']>;
  supportsTroonAccess?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFacilitiesV3Args = {
  allowsIncomingPriveRequests?: InputMaybe<Scalars['Boolean']['input']>;
  allowsOutgoingPriveRequests?: InputMaybe<Scalars['Boolean']['input']>;
  brands?: InputMaybe<Array<FacilityBrand>>;
  countryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  favorite?: InputMaybe<Scalars['Boolean']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  idOrSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  isBookable?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<FacilityLocationInput>;
  macroRegionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  oldTroonCardGroupId?: InputMaybe<Scalars['String']['input']>;
  regionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sortBy?: InputMaybe<FacilitySortField>;
  sortDirection?: InputMaybe<SortDirection>;
  supportsTroonAccess?: InputMaybe<Scalars['Boolean']['input']>;
  supportsTroonAccessPrive?: InputMaybe<Scalars['Boolean']['input']>;
  supportsTroonAdvantage?: InputMaybe<Scalars['Boolean']['input']>;
  supportsTroonRewards?: InputMaybe<Scalars['Boolean']['input']>;
  supportsVisaPrive?: InputMaybe<Scalars['Boolean']['input']>;
  troonAccessPlusDeal?: InputMaybe<Scalars['Boolean']['input']>;
  types?: InputMaybe<Array<FacilityType>>;
};


export type QueryFacilityArgs = {
  filterUnavailable?: InputMaybe<Scalars['Boolean']['input']>;
  idOrSlug: Scalars['String']['input'];
};


export type QueryFacilityClosuresArgs = {
  facilityIdOrSlug: Scalars['String']['input'];
};


export type QueryFacilityNotesArgs = {
  day?: InputMaybe<CalendarDayInput>;
  facilityIdOrSlug: Scalars['String']['input'];
};


export type QueryFacilityRedirectArgs = {
  facilitySlug: Scalars['String']['input'];
  urlVariant?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFacilityRewardRedemptionChartArgs = {
  facilityId: Scalars['String']['input'];
};


export type QueryFavoriteCoursesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetClaimedBenefitCodesArgs = {
  benefit?: InputMaybe<Benefit>;
};


export type QueryGuestPassArgs = {
  guestPassId: Scalars['String']['input'];
  reservationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGuestPassesArgs = {
  reservationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNearbyCoursesArgs = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};


export type QueryNearbyFacilitiesArgs = {
  cardGroupId?: InputMaybe<Scalars['String']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  radiusInMiles?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNextUpcomingReservationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryReservationArgs = {
  id: Scalars['String']['input'];
};


export type QueryReservationInviteArgs = {
  reservationId: Scalars['String']['input'];
  shareInviteId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryReservationPaymentInfoArgs = {
  reservationId: Scalars['String']['input'];
  rewardType?: InputMaybe<RedeemableRewardType>;
};


export type QueryReservationRedeemableRewardsArgs = {
  reservationId: Scalars['String']['input'];
};


export type QueryReservationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRetoolGetActiveTroonCardSubscriptionByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryRetoolGetMergeUserAccountsArgs = {
  aRewardsId: Scalars['String']['input'];
  bRewardsId: Scalars['String']['input'];
};


export type QueryRetoolUserInfoArgs = {
  userId: Scalars['String']['input'];
};


export type QuerySearchArgs = {
  query: Scalars['String']['input'];
};


export type QuerySearchCoursesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type QuerySearchFacilitiesArgs = {
  includeGeocoded?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  radiusInMiles?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchFacilitiesV2Args = {
  brand?: InputMaybe<FacilityBrand>;
  cardGroupId?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  filterUnavailable?: InputMaybe<Scalars['Boolean']['input']>;
  includeGeocoded?: InputMaybe<Scalars['Boolean']['input']>;
  includeLocations?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  radiusInMiles?: InputMaybe<Scalars['Int']['input']>;
  stateId?: InputMaybe<Scalars['String']['input']>;
  supportsTroonAccess?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<FacilityType>;
};


export type QuerySearchUsersArgs = {
  query: Scalars['String']['input'];
};


export type QuerySuggestedReservationUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  reservationId: Scalars['String']['input'];
};


export type QueryTeeTimeAlertArgs = {
  id: Scalars['String']['input'];
};


export type QueryTeeTimeAlertsArgs = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTestDelayArgs = {
  delay: Scalars['Int']['input'];
};


export type QueryTroonAccessReservationUpsellArgs = {
  reservationId: Scalars['String']['input'];
};


export type QueryTroonAccessTeeTimeDealsByCourseArgs = {
  courseLimit?: InputMaybe<Scalars['Int']['input']>;
  day?: InputMaybe<CalendarDayInput>;
  sort?: InputMaybe<TroonAccessTeeTimeDealSort>;
  teeTimeLimit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTroonCardSubscriptionArgs = {
  id: Scalars['String']['input'];
};


export type QueryTroonCardSubscriptionProductArgs = {
  id: Scalars['String']['input'];
  promoCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTroonCardSubscriptionProductsArgs = {
  promoCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserArgs = {
  id: Scalars['String']['input'];
};


export type QueryUserExistsArgs = {
  email: Scalars['String']['input'];
};


export type QueryZipcodeFacilitiesArgs = {
  distanceInMiles?: InputMaybe<Scalars['Float']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  zipcode: Scalars['String']['input'];
};

export type Receipt = {
  disclaimer?: Maybe<Scalars['String']['output']>;
  dueLater: Currency;
  dueNow: Currency;
  items: Array<ReceiptItem>;
  reimbursement?: Maybe<Currency>;
  reimbursementDisclaimer?: Maybe<Scalars['String']['output']>;
  savings: Currency;
  total: Currency;
  totalPaid?: Maybe<Currency>;
  totalStatus: TotalStatus;
};

export type ReceiptItem = {
  amount: Currency;
  itemType: ReceiptItemType;
  label: Scalars['String']['output'];
};

export enum ReceiptItemType {
  Charge = 'CHARGE',
  Discount = 'DISCOUNT'
}

export type RedeemableReward = {
  cash: Currency;
  notRedeemableReason?: Maybe<NotRedeemableReason>;
  points: Scalars['Int']['output'];
  type: RedeemableRewardType;
};

export enum RedeemableRewardType {
  DiscountedRound = 'DiscountedRound',
  FreeRound = 'FreeRound'
}

export type RefreshToken = {
  accessToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  user: User;
};

export type RefreshTokenInput = {
  refreshToken: Scalars['String']['input'];
};

export type Region = {
  countryId: Scalars['String']['output'];
  countryName: Scalars['String']['output'];
  facilityCount: Scalars['Int']['output'];
  hero?: Maybe<Media>;
  heroMediaId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  troonAccessFacilityCount: Scalars['Int']['output'];
};

export type Reservation = {
  allowsGuestPasses: Scalars['Boolean']['output'];
  autoApplyGuestPasses: Scalars['Boolean']['output'];
  bookingRateType?: Maybe<TeeTimeRateType>;
  calendarEvent: CalendarEvent;
  cancelDayTime?: Maybe<CalendarDayTime>;
  cancelFee?: Maybe<Currency>;
  checkInEnabled: Scalars['Boolean']['output'];
  course: Course;
  courseId: Scalars['String']['output'];
  dayTime: CalendarDayTime;
  dayTimeString: Scalars['String']['output'];
  facility: Facility;
  facilityId: Scalars['String']['output'];
  guestPassDiscount?: Maybe<Currency>;
  guestPasses: Array<GuestPass>;
  holeCount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  includesCart: Scalars['Boolean']['output'];
  isCancelWindow: Scalars['Boolean']['output'];
  isCheckInWindow: Scalars['Boolean']['output'];
  isHotDeal: Scalars['Boolean']['output'];
  isPastStartTime: Scalars['Boolean']['output'];
  isToday: Scalars['Boolean']['output'];
  owner: User;
  ownerId: Scalars['String']['output'];
  /** @deprecated This is not guaranteed to be available anymore. Use bookingRateType instead */
  ownerReservationUser?: Maybe<ReservationUser>;
  playerCount: Scalars['Int']['output'];
  publicFee?: Maybe<Currency>;
  shareInviteId?: Maybe<Scalars['String']['output']>;
  shareInviteUrl?: Maybe<Scalars['String']['output']>;
  state: ReservationState;
  teeTimeId: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  totalTransactionFees?: Maybe<Currency>;
  troonAccessFee?: Maybe<Currency>;
  troonAccessPlusFee?: Maybe<Currency>;
  users: Array<ReservationUser>;
};

export type ReservationCheckInEligibility = {
  canCheckIn: Scalars['Boolean']['output'];
  ineligibleReason?: Maybe<Scalars['String']['output']>;
};

export type ReservationCheckInResponse = {
  pointsEarned: Scalars['Int']['output'];
  reservation: Reservation;
};

export type ReservationPaymentInfo = {
  receipt: Receipt;
  rewardPointsEarned: Scalars['Int']['output'];
  rewardPointsUsed: Scalars['Int']['output'];
};

export enum ReservationState {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type ReservationUser = {
  fee: Currency;
  guestPass?: Maybe<GuestPass>;
  id: Scalars['String']['output'];
  isCheckedIn: Scalars['Boolean']['output'];
  rateType: TeeTimeRateType;
  reservationId: Scalars['String']['output'];
  state: ReservationUserState;
  user?: Maybe<User>;
};

export enum ReservationUserState {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Empty = 'EMPTY',
  Invited = 'INVITED'
}

export type ResetPassword = {
  destination: Scalars['String']['output'];
  expirationInMinutes: Scalars['Int']['output'];
  medium: Scalars['String']['output'];
};

export type ResetPasswordConfirmDto = {
  needsConfirmation: Scalars['Boolean']['output'];
};

export type RetoolAddExtraEzlinksSponsorInput = {
  appliesToAllUsers: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  rateType: TeeTimeRateType;
  sponsorId: Scalars['Int']['input'];
};

export type RetoolAttachExtraEzlinksSponsorToCourseInput = {
  appliesToAllUsers?: InputMaybe<Scalars['Boolean']['input']>;
  courseId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  rateType?: InputMaybe<TeeTimeRateType>;
  sponsorId: Scalars['Int']['input'];
};

export type RetoolClaimGuestPassInput = {
  guestPassId: Scalars['String']['input'];
  userEmailOrRewardId?: InputMaybe<Scalars['String']['input']>;
};

export type RetoolDeleteExtraEzlinksSponsorFromCourseInput = {
  courseId: Scalars['String']['input'];
  sponsorId: Scalars['Int']['input'];
};

export type RetoolLightSpeedInfo = {
  accessToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export type RetoolUserInfo = {
  ezlinksMemberships: Array<EzlinkMembership>;
};

export type RetriedJobsResponse = {
  retryCount: Scalars['Int']['output'];
  retryFailedCount: Scalars['Int']['output'];
};

export type RewardRedemptionChartDto = {
  domesticRegions: Array<FacilityRewardRedemptionRegion>;
  internationalRegions: Array<FacilityRewardRedemptionRegion>;
};

export enum RewardTransactionType {
  Award = 'AWARD',
  Credit = 'CREDIT',
  Redemption = 'REDEMPTION'
}

export enum Role {
  Admin = 'ADMIN',
  BetaUser = 'BETA_USER',
  Operator = 'OPERATOR',
  User = 'USER'
}

export enum RoundHolesOption {
  Eighteen = 'EIGHTEEN',
  Nine = 'NINE',
  NineOrEighteen = 'NINE_OR_EIGHTEEN'
}

export type SearchFacilitiesResponse = {
  cursor?: Maybe<Scalars['String']['output']>;
  facilities: Array<Facility>;
  locations: Array<Location>;
  unavailableFacilities: Array<Facility>;
};

export type SearchResponse = {
  facilities: Array<Facility>;
  places: Array<Place>;
  regions: Array<Region>;
};

export type SignUp = {
  succeeded: Scalars['Boolean']['output'];
};

export type SignUpInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  programSignUpType?: InputMaybe<ProgramSignUpType>;
  zipcode: Scalars['String']['input'];
};

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum StripeClientSecretIntentType {
  Payment = 'PAYMENT',
  Setup = 'SETUP'
}

export type TeeTimeAlert = {
  emailEnabled: Scalars['Boolean']['output'];
  facilityTrigger: FacilityTeeTimeAlertTrigger;
  id: Scalars['String']['output'];
  pushEnabled: Scalars['Boolean']['output'];
  smsEnabled: Scalars['Boolean']['output'];
  state: TeeTimeAlertState;
};

export enum TeeTimeAlertState {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Paused = 'PAUSED'
}

export type TeeTimeFee = {
  amount: Currency;
  cancellationFee: Currency;
  cancellationThresholdInHours: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  includesCart: Scalars['Boolean']['output'];
  originalAmount: Currency;
};

export enum TeeTimeRateType {
  LocalCard = 'LOCAL_CARD',
  Public = 'PUBLIC',
  PublicExtra = 'PUBLIC_EXTRA',
  TroonAccess = 'TROON_ACCESS',
  TroonAccessPlus = 'TROON_ACCESS_PLUS',
  TroonCardFoursome = 'TROON_CARD_FOURSOME',
  TroonCardTwosome = 'TROON_CARD_TWOSOME'
}

export type TeeTimeReservationInfo = {
  availableSpots: Scalars['Int']['output'];
  fee: TeeTimeFee;
  groupId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  includesCart: Scalars['Boolean']['output'];
  includesPracticeBalls: Scalars['Boolean']['output'];
  numberOfHoles: Scalars['Int']['output'];
};

export enum TotalStatus {
  DueLater = 'DUE_LATER',
  DueNow = 'DUE_NOW',
  Paid = 'PAID'
}

export type TroonAccessAggregatedSavings = {
  reservations: Array<TroonAccessReservationSavings>;
  totalAccessDiscount: Currency;
  totalAccessPlusDiscount: Currency;
};

export type TroonAccessCourseSavings = {
  avgSavings: Currency;
  roundsNeeded: Scalars['Int']['output'];
};

export type TroonAccessReservationSavings = {
  accessDiscount: Currency;
  accessPlusDiscount: Currency;
  reservation: Reservation;
};

export type TroonAccessReservationUpsell = {
  displayMessage: Scalars['String']['output'];
  savings: Currency;
};

export type TroonAccessTeeTimeDeal = {
  accessPlusRate: Currency;
  course: Course;
  courseId: Scalars['String']['output'];
  dayTime: CalendarDayTime;
  discount: Currency;
  facility: Facility;
  facilityId: Scalars['String']['output'];
  maxPlayers: Scalars['Int']['output'];
  minPlayers: Scalars['Int']['output'];
  publicRate: Currency;
  teeTimeId: Scalars['String']['output'];
};

export type TroonAccessTeeTimeDealByCourse = {
  course: Course;
  deals: Array<TroonAccessTeeTimeDeal>;
};

export enum TroonAccessTeeTimeDealSort {
  DayTime = 'DAY_TIME',
  Discount = 'DISCOUNT'
}

export type TroonAccessTotalSavings = {
  avgAccessPlusSavingsPerRound: Currency;
  avgAccessPlusSavingsPerUser: Currency;
  avgAccessSavingsPerRound: Currency;
  avgAccessSavingsPerUser: Currency;
};

export type TroonCardAssociateInfoDto = {
  associateName: Scalars['String']['input'];
  facilityId: Scalars['String']['input'];
  operatorId?: InputMaybe<Scalars['String']['input']>;
  publicRate?: InputMaybe<Scalars['String']['input']>;
  rewardsId: Scalars['String']['input'];
};

export type TroonCardAssociateResponseDto = {
  accessRate?: Maybe<Currency>;
  email: Scalars['String']['output'];
  publicRate?: Maybe<Currency>;
  rewardsId: Scalars['String']['output'];
};

export type TroonCardSubscription = {
  autoRenews: Scalars['Boolean']['output'];
  discountAmount: Currency;
  endDayTime?: Maybe<CalendarDayTime>;
  id: Scalars['String']['output'];
  manageSubscriptionUrl?: Maybe<Scalars['String']['output']>;
  nextInvoiceAmount?: Maybe<Currency>;
  nextInvoiceDate?: Maybe<CalendarDayTime>;
  productAddOns: Array<TroonCardSubscriptionAddonType>;
  productType: TroonCardSubscriptionProductType;
  startDayTime?: Maybe<CalendarDayTime>;
  status: TroonCardSubscriptionStatus;
  subscriptionName: Scalars['String']['output'];
  subtotalAmount: Currency;
  taxAmount: Currency;
  totalAmount: Currency;
  unlimitedGuestPass: Scalars['Boolean']['output'];
  updateSubscriptionUrl?: Maybe<Scalars['String']['output']>;
};

export enum TroonCardSubscriptionAddonType {
  UnlimitedGuestPasses = 'UNLIMITED_GUEST_PASSES'
}

export type TroonCardSubscriptionIntent = {
  disclosure: Scalars['String']['output'];
  discountAmount: Currency;
  promoCode?: Maybe<Scalars['String']['output']>;
  stripeClientSecret: Scalars['String']['output'];
  stripeClientSecretIntentType: StripeClientSecretIntentType;
  stripeCustomerEphemeralKey?: Maybe<Scalars['String']['output']>;
  stripeCustomerId: Scalars['String']['output'];
  subscriptionName: Scalars['String']['output'];
  subtotalAmount: Currency;
  taxAmount: Currency;
  totalAmount: Currency;
  troonCardSubscriptionId: Scalars['String']['output'];
};

export type TroonCardSubscriptionProduct = {
  active: Scalars['Boolean']['output'];
  additionalValueProps?: Maybe<Array<Scalars['String']['output']>>;
  amount: Currency;
  autoRenew: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  disclosure?: Maybe<Scalars['String']['output']>;
  discountAmount: Currency;
  id: Scalars['String']['output'];
  isPopular: Scalars['Boolean']['output'];
  monthlyAmount: Currency;
  monthlyDiscountAmount: Currency;
  monthlySubtotalAmount: Currency;
  monthlyTotalAmount: Currency;
  subscriptionName: Scalars['String']['output'];
  subtotalAmount: Currency;
  totalAmount: Currency;
  type: TroonCardSubscriptionProductType;
  valueProps: Array<Scalars['String']['output']>;
};

export enum TroonCardSubscriptionProductType {
  TroonAccess = 'TROON_ACCESS',
  TroonAccessPlus = 'TROON_ACCESS_PLUS'
}

export enum TroonCardSubscriptionStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Refunded = 'REFUNDED'
}

export enum TroonRewardsAppStatus {
  Exists = 'EXISTS',
  ExistsAndFirstLogin = 'EXISTS_AND_FIRST_LOGIN',
  NoAccount = 'NO_ACCOUNT'
}

export type TroonSubscriptionRateDiscounts = {
  alert?: Maybe<TroonSubscriptionRateDiscountsAlert>;
  troonAccess?: Maybe<Currency>;
  troonAccessPlus?: Maybe<Currency>;
};

export type TroonSubscriptionRateDiscountsAlert = {
  accessPlusSavingsPerRound: TroonAccessCourseSavings;
  accessSavingsPerRound: TroonAccessCourseSavings;
  alertId: Scalars['String']['output'];
};

export type UtmAttributesInput = {
  campaign?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type UpcomingReservations = {
  hasMoreReservations: Scalars['Boolean']['output'];
  reservations: Array<Reservation>;
};

export type UpdateEmailInput = {
  newEmail: Scalars['String']['input'];
};

export type UpdateFacilityTeeTimeAlertInput = {
  alertId: Scalars['String']['input'];
  trigger: CreateFacilityTeeTimeAlertTriggerInput;
};

export type UpdatePhoneNumberInput = {
  phoneNumber: Scalars['String']['input'];
};

export type UpdatePhoneNumberResponse = {
  requiresConfirmation: Scalars['Boolean']['output'];
};

export type User = {
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  oldTroonCardGroup?: Maybe<OldTroonCardGroup>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  referralCode: Scalars['String']['output'];
  role: Role;
  supportsTroonRewards: Scalars['Boolean']['output'];
  troonAccessProductType?: Maybe<TroonCardSubscriptionProductType>;
  troonCardId?: Maybe<Scalars['String']['output']>;
  troonRewardsId: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

export type UserExists = {
  status: TroonRewardsAppStatus;
};

export type UserGuestPasses = {
  accepted: Array<GuestPass>;
  available: Array<GuestPass>;
  pending: Array<GuestPass>;
};

export type UserRewardTransaction = {
  dayCreated: CalendarDay;
  facilityName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  points: Scalars['Int']['output'];
  transactionType: RewardTransactionType;
};

export type UserRewards = {
  availablePoints: Scalars['Int']['output'];
  currentYearPoints: Scalars['Int']['output'];
  level: UserRewardsLevel;
  nextLevel?: Maybe<UserRewardsLevel>;
  pointsToNextLevel: Scalars['Int']['output'];
  previousYear1Points: Scalars['Int']['output'];
  previousYear2Points: Scalars['Int']['output'];
  previousYear3Points: Scalars['Int']['output'];
};

export enum UserRewardsLevel {
  Gold = 'GOLD',
  Member = 'MEMBER',
  Platinum = 'PLATINUM',
  Silver = 'SILVER'
}

export type UserSettings = {
  pushNotificationsEnabled: Scalars['Boolean']['output'];
};

export type UserWaiver = {
  lastSignedDate: Scalars['DateTime']['output'];
};

export type AccountReservationsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountReservationsCountQuery = { reservations: Array<{ id: string }> };

export type ConfirmTroonCardSubscriptionMutationVariables = Exact<{
  subscriptionId: Scalars['String']['input'];
}>;


export type ConfirmTroonCardSubscriptionMutation = { confirmation: { id: string, status: TroonCardSubscriptionStatus, subscriptionName: string, autoRenews: boolean, startDayTime?: { day: { year: number, month: number, day: number }, time: { hour: number, minute: number } } | null, endDayTime?: { day: { year: number, month: number, day: number }, time: { hour: number, minute: number } } | null, nextInvoiceDate?: { day: { year: number, month: number, day: number }, time: { hour: number, minute: number } } | null, totalAmount: { displayValue: string, value: any }, discountAmount: { displayValue: string, value: any }, taxAmount: { displayValue: string, value: any }, subtotalAmount: { displayValue: string, value: any } } };

export type FacilityCardFragmentFragment = { slug: string, name: string, type: FacilityType, isBookable: boolean, metadata?: { description?: string | null, address?: { city?: string | null, state?: string | null } | null, hero?: { url?: string | null } | null, logo?: { url?: string | null } | null, gallery: Array<{ url?: string | null }> } | null } & { ' $fragmentName'?: 'FacilityCardFragmentFragment' };

export type ToggleFavoriteFacilityMutationVariables = Exact<{
  facilityId: Scalars['String']['input'];
  isFavorite: Scalars['Boolean']['input'];
}>;


export type ToggleFavoriteFacilityMutation = { toggleFavoriteFacility: { name: string, isFavorite?: boolean | null } };

export type FacilityHeaderButtonsFragment = (
  { id: string, name: string, slug: string, isBookable: boolean, isFavorite?: boolean | null, metadata?: { description?: string | null, hero?: { url?: string | null } | null, logo?: { url?: string | null } | null } | null }
  & { ' $fragmentRefs'?: { 'TeeTimeAlertFormFragment': TeeTimeAlertFormFragment } }
) & { ' $fragmentName'?: 'FacilityHeaderButtonsFragment' };

export type AddFavoriteFacilityMutationVariables = Exact<{
  facilityId: Scalars['String']['input'];
}>;


export type AddFavoriteFacilityMutation = { toggleFavoriteFacility: { isFavorite?: boolean | null } };

export type UpdateFacilityTeeTimeAlertMutationVariables = Exact<{
  alertId: Scalars['String']['input'];
  year: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
  day: Scalars['Int']['input'];
  startAt: Scalars['Int']['input'];
  endAt: Scalars['Int']['input'];
  players?: InputMaybe<Scalars['Int']['input']>;
  courseIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  pushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  emailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateFacilityTeeTimeAlertMutation = { updateFacilityTeeTimeAlert: { id: string, state: TeeTimeAlertState } };

export type DeleteTeeTimeAlertMutationVariables = Exact<{
  alertId: Scalars['String']['input'];
}>;


export type DeleteTeeTimeAlertMutation = { deleteTeeTimeAlert: { id: string } };

export type TeeTimeAlertFragment = { id: string, state: TeeTimeAlertState, pushEnabled: boolean, emailEnabled: boolean, facilityTrigger: { courseIds: Array<string>, players?: number | null, day: { year: number, month: number, day: number }, startAt?: { hour: number } | null, endAt?: { hour: number } | null, facility: (
      { name: string, slug: string, timezone: string, metadata?: { hero?: { url?: string | null } | null } | null }
      & { ' $fragmentRefs'?: { 'TeeTimeAlertFormFragment': TeeTimeAlertFormFragment } }
    ), courseTeeTimesPreview: { hasMore: boolean, teeTimes: Array<{ id: string, dayTime: { time: { hour: number, minute: number } } }> } } } & { ' $fragmentName'?: 'TeeTimeAlertFragment' };

export type DayTimeFragment = { day: { year: number, month: number, day: number }, time: { hour: number, minute: number } } & { ' $fragmentName'?: 'DayTimeFragment' };

export type DayFragment = { year: number, month: number, day: number } & { ' $fragmentName'?: 'DayFragment' };

export type TimeFragment = { hour: number, minute: number } & { ' $fragmentName'?: 'TimeFragment' };

export type CurrencyFragment = { value: any, code: CurrencyCode, displayValue: string } & { ' $fragmentName'?: 'CurrencyFragment' };

export type CurrencyWithCentsFragment = (
  { cents?: number | null }
  & { ' $fragmentRefs'?: { 'CurrencyFragment': CurrencyFragment } }
) & { ' $fragmentName'?: 'CurrencyWithCentsFragment' };

export type AddressFragment = { street?: string | null, street2?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null } & { ' $fragmentName'?: 'AddressFragment' };

export type FacilityRedirectQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  urlVariant?: InputMaybe<Scalars['String']['input']>;
}>;


export type FacilityRedirectQuery = { facilityRedirect: { variation: string, redirectUrl: string } };

export type EmailMagicLinkMutationVariables = Exact<{
  email: Scalars['String']['input'];
  redirect?: InputMaybe<Scalars['String']['input']>;
}>;


export type EmailMagicLinkMutation = { emailMagicLink: { ok: boolean } };

export type ConfirmEmailMagicLinkMutationVariables = Exact<{
  email: Scalars['String']['input'];
  confirmationCode: Scalars['String']['input'];
}>;


export type ConfirmEmailMagicLinkMutation = { confirmEmailMagicLink: { accessToken: string, refreshToken: string, user: { id: string, email: string, firstName: string, lastName: string, troonRewardsId: string, troonAccessProductType?: TroonCardSubscriptionProductType | null } } };

export type TeeTimeAlertFormFragment = { name: string, timezone: string, courses: Array<{ id: string, slug: string, name: string, supportsTeeTimeAlerts: boolean, bookingWindowInDays: number }> } & { ' $fragmentName'?: 'TeeTimeAlertFormFragment' };

export type CreateFacilityTeeTimeAlertMutationVariables = Exact<{
  year: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
  day: Scalars['Int']['input'];
  startAt: Scalars['Int']['input'];
  endAt: Scalars['Int']['input'];
  players?: InputMaybe<Scalars['Int']['input']>;
  courseIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  pushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  emailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateFacilityTeeTimeAlertMutation = { createFacilityTeeTimeAlert: { id: string, state: TeeTimeAlertState } };

export type GolferExistsQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type GolferExistsQuery = { userExists: { status: TroonRewardsAppStatus } };

export type AssociateAccessInfoQueryVariables = Exact<{
  subscriptionId: Scalars['String']['input'];
}>;


export type AssociateAccessInfoQuery = { associateTroonAccessInfo: { email: string, publicRate?: { displayValue: string, value: any } | null, accessRate?: { displayValue: string, value: any } | null } };

export type SetupTroonCardSubscriptionByAssociateMutationVariables = Exact<{
  associateInfo: TroonCardAssociateInfoDto;
  productId: Scalars['String']['input'];
  promoCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetupTroonCardSubscriptionByAssociateMutation = { subscription: { stripeClientSecret: string, stripeCustomerId: string, subscriptionName: string, troonCardSubscriptionId: string, stripeClientSecretIntentType: StripeClientSecretIntentType, promoCode?: string | null, disclosure: string, totalAmount: { displayValue: string, value: any, code: CurrencyCode, cents?: number | null }, subtotalAmount: { displayValue: string, value: any }, discountAmount: { displayValue: string, value: any }, taxAmount: { displayValue: string, value: any } } };

export type AccountDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountDetailsQuery = { userRewards: { availablePoints: number, currentYearPoints: number, level: UserRewardsLevel, pointsToNextLevel: number, nextLevel?: UserRewardsLevel | null } };

export type ConfirmUpdateEmailMutationVariables = Exact<{
  newEmail: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type ConfirmUpdateEmailMutation = { confirmUpdateEmail: { email: string } };

export type ActivityQueryVariables = Exact<{ [key: string]: never; }>;


export type ActivityQuery = { transactions: Array<{ points: number, facilityName: string, transactionType: RewardTransactionType, dayCreated: { year: number, month: number, day: number } }> };

export type TeeTimeAlertsQueryVariables = Exact<{ [key: string]: never; }>;


export type TeeTimeAlertsQuery = { teeTimeAlerts: Array<{ ' $fragmentRefs'?: { 'TeeTimeAlertFragment': TeeTimeAlertFragment } }> };

export type UpdateNameMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
}>;


export type UpdateNameMutation = { updateName: { firstName: string, lastName: string } };

export type UpdateEmailMutationVariables = Exact<{
  newEmail: Scalars['String']['input'];
}>;


export type UpdateEmailMutation = { updateEmail: { ok: boolean } };

export type UpdatePasswordMutationVariables = Exact<{
  oldPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type UpdatePasswordMutation = { changePassword: { ok: boolean } };

export type AllReservationsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllReservationsQuery = { reservations: Array<{ id: string, includesCart: boolean, playerCount: number, holeCount: number, state: ReservationState, dayTime: { day: { year: number, month: number, day: number }, time: { hour: number, minute: number } }, facility: { name: string, metadata?: { hero?: { url?: string | null } | null } | null }, course: { name: string } }> };

export type ExternalInfoQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type ExternalInfoQuery = { facilityRedirect: { redirectUrl: string } };

export type FacilityMapQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FacilityMapQuery = { facility: { type: FacilityType, latitude?: number | null, longitude?: number | null } };

export type ClaimedBenefitCodeQueryVariables = Exact<{
  benefit: Benefit;
}>;


export type ClaimedBenefitCodeQuery = { codes: Array<{ code: string }> };

export type ClaimBenefitCodeMutationVariables = Exact<{
  benefit: Benefit;
}>;


export type ClaimBenefitCodeMutation = { code: { code: string } };

export type CreateOrUpdateAccessGiftPurchaseMutationVariables = Exact<{
  productId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  giftParams: AccessGiftPurchaseInput;
}>;


export type CreateOrUpdateAccessGiftPurchaseMutation = { gift: { id: string, status: GiftingAccessPurchaseStatus, purchaserName: string, purchaserEmail: string, recipientName: string, recipientEmail: string, message?: string | null, promoCode?: string | null, stripeClientSecret: string, deliverAt: string, totalAmount: { displayValue: string, value: any, code: CurrencyCode, cents?: number | null }, subtotalAmount: { displayValue: string, value: any }, discountAmount: { displayValue: string, value: any }, taxAmount: { displayValue: string, value: any } } };

export type ConfirmAccessGiftMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ConfirmAccessGiftMutation = { confirmation: { status: GiftingAccessPurchaseStatus, purchaserEmail: string, recipientName: string, recipientEmail: string, message?: string | null, deliverAt: string, totalAmount: { displayValue: string, value: any, code: CurrencyCode, cents?: number | null }, subtotalAmount: { displayValue: string, value: any }, discountAmount: { displayValue: string, value: any }, taxAmount: { displayValue: string, value: any } } };

export type UserRewardsLevelQueryVariables = Exact<{ [key: string]: never; }>;


export type UserRewardsLevelQuery = { userRewards: { level: UserRewardsLevel } };

export type GetRedemptionQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type GetRedemptionQuery = { gift: { redemptionCode?: string | null, product?: { ' $fragmentRefs'?: { 'GiftProductFragment': GiftProductFragment } } | null } };

export type GiftProductFragment = { id: string, subscriptionName: string, description: string, valueProps: Array<string>, autoRenew: boolean, disclosure?: string | null, type: TroonCardSubscriptionProductType } & { ' $fragmentName'?: 'GiftProductFragment' };

export type SetupTroonCardSubscriptionMutationVariables = Exact<{
  productId: Scalars['String']['input'];
  promoCode?: InputMaybe<Scalars['String']['input']>;
  utm?: InputMaybe<UtmAttributesInput>;
}>;


export type SetupTroonCardSubscriptionMutation = { subscription: { stripeClientSecret: string, stripeCustomerId: string, subscriptionName: string, troonCardSubscriptionId: string, stripeClientSecretIntentType: StripeClientSecretIntentType, promoCode?: string | null, disclosure: string, totalAmount: { displayValue: string, value: any, code: CurrencyCode, cents?: number | null }, subtotalAmount: { displayValue: string, value: any }, discountAmount: { displayValue: string, value: any }, taxAmount: { displayValue: string, value: any } } };

export type ReservationInviteQueryVariables = Exact<{
  reservationId: Scalars['String']['input'];
  shareInviteId: Scalars['String']['input'];
  invite: Scalars['Boolean']['input'];
}>;


export type ReservationInviteQuery = { reservation?: { ' $fragmentRefs'?: { 'ShareReservationFragment': ShareReservationFragment } }, reservationInvite?: { ' $fragmentRefs'?: { 'ShareReservationFragment': ShareReservationFragment } } };

export type ShareReservationFragment = { holeCount: number, includesCart: boolean, playerCount: number, owner: { firstName: string, lastName: string }, users: Array<{ id: string, state: ReservationUserState, user?: { id: string } | null }>, dayTime: { day: { year: number, month: number, day: number }, time: { hour: number, minute: number } }, facility: { name: string, metadata?: { logo?: { url?: string | null } | null, hero?: { url?: string | null } | null } | null } } & { ' $fragmentName'?: 'ShareReservationFragment' };

export type JoinReservationMutationVariables = Exact<{
  reservationId: Scalars['String']['input'];
  shareInviteId: Scalars['String']['input'];
}>;


export type JoinReservationMutation = { joinReservation: { id: string } };

export type AcceptReservationInviteMutationVariables = Exact<{
  reservationUserId: Scalars['String']['input'];
}>;


export type AcceptReservationInviteMutation = { acceptReservationInvite: { id: string } };

export type RejectReservationInviteMutationVariables = Exact<{
  reservationUserId: Scalars['String']['input'];
}>;


export type RejectReservationInviteMutation = { rejectReservationInvite: { ok: boolean } };

export type ReservationInformationQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ReservationInformationQuery = { accessUpsell?: { savings: { displayValue: string } } | null, guestPasses: { available: Array<{ id: string, status: GuestPassStatus }>, pending: Array<{ id: string, status: GuestPassStatus }>, accepted: Array<{ id: string, status: GuestPassStatus }> }, activeTroonCardSubscription?: { productAddOns: Array<TroonCardSubscriptionAddonType> } | null };

export type CancelReservationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CancelReservationMutation = { cancelReservation: { id: string } };

export type LeaveReservationMutationVariables = Exact<{
  reservationUserId: Scalars['String']['input'];
}>;


export type LeaveReservationMutation = { leaveReservation: { ok: boolean } };

export type AddGuestPassToUserMutationVariables = Exact<{
  reservationUserId: Scalars['String']['input'];
}>;


export type AddGuestPassToUserMutation = { addGuestPassToUser: { id: string } };

export type SuggestedReservationUsersQueryVariables = Exact<{
  reservationId: Scalars['String']['input'];
}>;


export type SuggestedReservationUsersQuery = { suggestedReservationUsers: Array<{ id: string, email: string, firstName: string, lastName: string, troonAccessProductType?: TroonCardSubscriptionProductType | null }> };

export type InviteUserToReservationMutationVariables = Exact<{
  reservationUserId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type InviteUserToReservationMutation = { inviteUserToReservation: { id: string } };

export type RemoveUserFromReservationMutationVariables = Exact<{
  reservationUserId: Scalars['String']['input'];
}>;


export type RemoveUserFromReservationMutation = { removeUserFromReservation: { id: string } };

export type DeactivateGuestPassMutationVariables = Exact<{
  guestPassId: Scalars['String']['input'];
}>;


export type DeactivateGuestPassMutation = { deactivateGuestPass: { reservation: { id: string } } };

export const FacilityCardFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FacilityCardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Facility"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isBookable"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gallery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<FacilityCardFragmentFragment, unknown>;
export const TeeTimeAlertFormFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeeTimeAlertForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Facility"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"courses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"supportsTeeTimeAlerts"}},{"kind":"Field","name":{"kind":"Name","value":"bookingWindowInDays"}}]}}]}}]} as unknown as DocumentNode<TeeTimeAlertFormFragment, unknown>;
export const FacilityHeaderButtonsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FacilityHeaderButtons"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Facility"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isBookable"}},{"kind":"Field","name":{"kind":"Name","value":"isFavorite"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeeTimeAlertForm"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeeTimeAlertForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Facility"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"courses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"supportsTeeTimeAlerts"}},{"kind":"Field","name":{"kind":"Name","value":"bookingWindowInDays"}}]}}]}}]} as unknown as DocumentNode<FacilityHeaderButtonsFragment, unknown>;
export const TeeTimeAlertFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeeTimeAlert"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TeeTimeAlert"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"pushEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"emailEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"facilityTrigger"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"courseIds"}},{"kind":"Field","name":{"kind":"Name","value":"day"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"day"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startAt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hour"}}]}},{"kind":"Field","name":{"kind":"Name","value":"endAt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hour"}}]}},{"kind":"Field","name":{"kind":"Name","value":"players"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeeTimeAlertForm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"courseTeeTimesPreview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasMore"}},{"kind":"Field","name":{"kind":"Name","value":"teeTimes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dayTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hour"}},{"kind":"Field","name":{"kind":"Name","value":"minute"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeeTimeAlertForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Facility"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"courses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"supportsTeeTimeAlerts"}},{"kind":"Field","name":{"kind":"Name","value":"bookingWindowInDays"}}]}}]}}]} as unknown as DocumentNode<TeeTimeAlertFragment, unknown>;
export const DayTimeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DayTime"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CalendarDayTime"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"day"}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hour"}},{"kind":"Field","name":{"kind":"Name","value":"minute"}}]}}]}}]} as unknown as DocumentNode<DayTimeFragment, unknown>;
export const DayFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Day"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CalendarDay"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"day"}}]}}]} as unknown as DocumentNode<DayFragment, unknown>;
export const TimeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Time"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CalendarTime"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hour"}},{"kind":"Field","name":{"kind":"Name","value":"minute"}}]}}]} as unknown as DocumentNode<TimeFragment, unknown>;
export const CurrencyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Currency"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Currency"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"displayValue"}}]}}]} as unknown as DocumentNode<CurrencyFragment, unknown>;
export const CurrencyWithCentsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurrencyWithCents"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Currency"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Currency"}},{"kind":"Field","name":{"kind":"Name","value":"cents"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Currency"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Currency"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"displayValue"}}]}}]} as unknown as DocumentNode<CurrencyWithCentsFragment, unknown>;
export const AddressFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Address"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}}]} as unknown as DocumentNode<AddressFragment, unknown>;
export const GiftProductFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GiftProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TroonCardSubscriptionProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"valueProps"}},{"kind":"Field","name":{"kind":"Name","value":"autoRenew"}},{"kind":"Field","name":{"kind":"Name","value":"disclosure"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<GiftProductFragment, unknown>;
export const ShareReservationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShareReservation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Reservation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"holeCount"}},{"kind":"Field","name":{"kind":"Name","value":"includesCart"}},{"kind":"Field","name":{"kind":"Name","value":"playerCount"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dayTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"day"}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hour"}},{"kind":"Field","name":{"kind":"Name","value":"minute"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ShareReservationFragment, unknown>;
export const AccountReservationsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"accountReservationsCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"reservations"},"name":{"kind":"Name","value":"allReservations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"upcoming"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"past"},"value":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AccountReservationsCountQuery, AccountReservationsCountQueryVariables>;
export const ConfirmTroonCardSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"confirmTroonCardSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"confirmation"},"name":{"kind":"Name","value":"confirmTroonCardSubscriptionPayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"troonCardSubscriptionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionName"}},{"kind":"Field","name":{"kind":"Name","value":"autoRenews"}},{"kind":"Field","name":{"kind":"Name","value":"startDayTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"day"}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hour"}},{"kind":"Field","name":{"kind":"Name","value":"minute"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"endDayTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"day"}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hour"}},{"kind":"Field","name":{"kind":"Name","value":"minute"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"nextInvoiceDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"day"}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hour"}},{"kind":"Field","name":{"kind":"Name","value":"minute"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtotalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<ConfirmTroonCardSubscriptionMutation, ConfirmTroonCardSubscriptionMutationVariables>;
export const ToggleFavoriteFacilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"toggleFavoriteFacility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isFavorite"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"toggleFavoriteFacility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"facilityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"isFavorite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isFavorite"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isFavorite"}}]}}]}}]} as unknown as DocumentNode<ToggleFavoriteFacilityMutation, ToggleFavoriteFacilityMutationVariables>;
export const AddFavoriteFacilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addFavoriteFacility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"toggleFavoriteFacility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"facilityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"isFavorite"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isFavorite"}}]}}]}}]} as unknown as DocumentNode<AddFavoriteFacilityMutation, AddFavoriteFacilityMutationVariables>;
export const UpdateFacilityTeeTimeAlertDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateFacilityTeeTimeAlert"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"alertId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"year"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"month"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"day"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startAt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endAt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"players"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"courseIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pushEnabled"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailEnabled"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFacilityTeeTimeAlert"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"alertId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"alertId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"trigger"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"day"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"year"},"value":{"kind":"Variable","name":{"kind":"Name","value":"year"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"month"},"value":{"kind":"Variable","name":{"kind":"Name","value":"month"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"day"},"value":{"kind":"Variable","name":{"kind":"Name","value":"day"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"startAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hour"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startAt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"minute"},"value":{"kind":"IntValue","value":"0"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"endAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hour"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endAt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"minute"},"value":{"kind":"IntValue","value":"0"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"players"},"value":{"kind":"Variable","name":{"kind":"Name","value":"players"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"courseIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"courseIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"pushEnabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pushEnabled"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"emailEnabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailEnabled"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]} as unknown as DocumentNode<UpdateFacilityTeeTimeAlertMutation, UpdateFacilityTeeTimeAlertMutationVariables>;
export const DeleteTeeTimeAlertDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteTeeTimeAlert"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"alertId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTeeTimeAlert"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"alertId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"alertId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteTeeTimeAlertMutation, DeleteTeeTimeAlertMutationVariables>;
export const FacilityRedirectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"facilityRedirect"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"urlVariant"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facilityRedirect"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"facilitySlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"Argument","name":{"kind":"Name","value":"urlVariant"},"value":{"kind":"Variable","name":{"kind":"Name","value":"urlVariant"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variation"}},{"kind":"Field","name":{"kind":"Name","value":"redirectUrl"}}]}}]}}]} as unknown as DocumentNode<FacilityRedirectQuery, FacilityRedirectQueryVariables>;
export const EmailMagicLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"emailMagicLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"redirect"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailMagicLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"redirectUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"redirect"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<EmailMagicLinkMutation, EmailMagicLinkMutationVariables>;
export const ConfirmEmailMagicLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"confirmEmailMagicLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"confirmationCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmEmailMagicLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"confirmationCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"confirmationCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"troonRewardsId"}},{"kind":"Field","name":{"kind":"Name","value":"troonAccessProductType"}}]}}]}}]}}]} as unknown as DocumentNode<ConfirmEmailMagicLinkMutation, ConfirmEmailMagicLinkMutationVariables>;
export const CreateFacilityTeeTimeAlertDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createFacilityTeeTimeAlert"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"year"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"month"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"day"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startAt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endAt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"players"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"courseIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pushEnabled"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailEnabled"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFacilityTeeTimeAlert"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"day"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"year"},"value":{"kind":"Variable","name":{"kind":"Name","value":"year"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"month"},"value":{"kind":"Variable","name":{"kind":"Name","value":"month"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"day"},"value":{"kind":"Variable","name":{"kind":"Name","value":"day"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"startAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hour"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startAt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"minute"},"value":{"kind":"IntValue","value":"0"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"endAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hour"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endAt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"minute"},"value":{"kind":"IntValue","value":"0"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"players"},"value":{"kind":"Variable","name":{"kind":"Name","value":"players"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"courseIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"courseIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"pushEnabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pushEnabled"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"emailEnabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailEnabled"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]} as unknown as DocumentNode<CreateFacilityTeeTimeAlertMutation, CreateFacilityTeeTimeAlertMutationVariables>;
export const GolferExistsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"golferExists"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userExists"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<GolferExistsQuery, GolferExistsQueryVariables>;
export const AssociateAccessInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"associateAccessInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"associateTroonAccessInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"troonCardSubscriptionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accessRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<AssociateAccessInfoQuery, AssociateAccessInfoQueryVariables>;
export const SetupTroonCardSubscriptionByAssociateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"setupTroonCardSubscriptionByAssociate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"associateInfo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TroonCardAssociateInfoDto"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"promoCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"subscription"},"name":{"kind":"Name","value":"setupTroonCardSubscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"troonCardAssociateInfo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"associateInfo"}}},{"kind":"Argument","name":{"kind":"Name","value":"troonCardSubscriptionProductId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}},{"kind":"Argument","name":{"kind":"Name","value":"promoCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"promoCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripeClientSecret"}},{"kind":"Field","name":{"kind":"Name","value":"stripeCustomerId"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionName"}},{"kind":"Field","name":{"kind":"Name","value":"troonCardSubscriptionId"}},{"kind":"Field","name":{"kind":"Name","value":"stripeClientSecretIntentType"}},{"kind":"Field","name":{"kind":"Name","value":"promoCode"}},{"kind":"Field","name":{"kind":"Name","value":"disclosure"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"cents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtotalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<SetupTroonCardSubscriptionByAssociateMutation, SetupTroonCardSubscriptionByAssociateMutationVariables>;
export const AccountDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"accountDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userRewards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availablePoints"}},{"kind":"Field","name":{"kind":"Name","value":"currentYearPoints"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"pointsToNextLevel"}},{"kind":"Field","name":{"kind":"Name","value":"nextLevel"}}]}}]}}]} as unknown as DocumentNode<AccountDetailsQuery, AccountDetailsQueryVariables>;
export const ConfirmUpdateEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"confirmUpdateEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmUpdateEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"newEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newEmail"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"confirmationCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<ConfirmUpdateEmailMutation, ConfirmUpdateEmailMutationVariables>;
export const ActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"activity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"transactions"},"name":{"kind":"Name","value":"userRewardTransactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"facilityName"}},{"kind":"Field","name":{"kind":"Name","value":"dayCreated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"day"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transactionType"}}]}}]}}]} as unknown as DocumentNode<ActivityQuery, ActivityQueryVariables>;
export const TeeTimeAlertsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"teeTimeAlerts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teeTimeAlerts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"isActive"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeeTimeAlert"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeeTimeAlertForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Facility"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"courses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"supportsTeeTimeAlerts"}},{"kind":"Field","name":{"kind":"Name","value":"bookingWindowInDays"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeeTimeAlert"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TeeTimeAlert"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"pushEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"emailEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"facilityTrigger"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"courseIds"}},{"kind":"Field","name":{"kind":"Name","value":"day"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"day"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startAt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hour"}}]}},{"kind":"Field","name":{"kind":"Name","value":"endAt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hour"}}]}},{"kind":"Field","name":{"kind":"Name","value":"players"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeeTimeAlertForm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"courseTeeTimesPreview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasMore"}},{"kind":"Field","name":{"kind":"Name","value":"teeTimes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dayTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hour"}},{"kind":"Field","name":{"kind":"Name","value":"minute"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TeeTimeAlertsQuery, TeeTimeAlertsQueryVariables>;
export const UpdateNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]} as unknown as DocumentNode<UpdateNameMutation, UpdateNameMutationVariables>;
export const UpdateEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"newEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newEmail"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<UpdateEmailMutation, UpdateEmailMutationVariables>;
export const UpdatePasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oldPassword"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changePassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"oldPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oldPassword"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"newPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const AllReservationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allReservations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"reservations"},"name":{"kind":"Name","value":"allReservations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"EnumValue","value":"DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dayTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"day"}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hour"}},{"kind":"Field","name":{"kind":"Name","value":"minute"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"includesCart"}},{"kind":"Field","name":{"kind":"Name","value":"playerCount"}},{"kind":"Field","name":{"kind":"Name","value":"holeCount"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<AllReservationsQuery, AllReservationsQueryVariables>;
export const ExternalInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"externalInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facilityRedirect"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"facilitySlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redirectUrl"}}]}}]}}]} as unknown as DocumentNode<ExternalInfoQuery, ExternalInfoQueryVariables>;
export const FacilityMapDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"facilityMap"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idOrSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterUnavailable"},"value":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}}]} as unknown as DocumentNode<FacilityMapQuery, FacilityMapQueryVariables>;
export const ClaimedBenefitCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"claimedBenefitCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"benefit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Benefit"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"codes"},"name":{"kind":"Name","value":"getClaimedBenefitCodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"benefit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"benefit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]} as unknown as DocumentNode<ClaimedBenefitCodeQuery, ClaimedBenefitCodeQueryVariables>;
export const ClaimBenefitCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"claimBenefitCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"benefit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Benefit"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"code"},"name":{"kind":"Name","value":"claimBenefitCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"benefit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"benefit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]} as unknown as DocumentNode<ClaimBenefitCodeMutation, ClaimBenefitCodeMutationVariables>;
export const CreateOrUpdateAccessGiftPurchaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createOrUpdateAccessGiftPurchase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"giftParams"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccessGiftPurchaseInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"gift"},"name":{"kind":"Name","value":"createOrUpdateAccessGiftPurchaseIntent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"troonCardSubscriptionProductId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"giftParams"},"value":{"kind":"Variable","name":{"kind":"Name","value":"giftParams"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"purchaserName"}},{"kind":"Field","name":{"kind":"Name","value":"purchaserEmail"}},{"kind":"Field","name":{"kind":"Name","value":"recipientName"}},{"kind":"Field","name":{"kind":"Name","value":"recipientEmail"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"promoCode"}},{"kind":"Field","name":{"kind":"Name","value":"stripeClientSecret"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"cents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtotalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliverAt"}}]}}]}}]} as unknown as DocumentNode<CreateOrUpdateAccessGiftPurchaseMutation, CreateOrUpdateAccessGiftPurchaseMutationVariables>;
export const ConfirmAccessGiftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"confirmAccessGift"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"confirmation"},"name":{"kind":"Name","value":"confirmAccessGiftPurchaseIntent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"purchaserEmail"}},{"kind":"Field","name":{"kind":"Name","value":"recipientName"}},{"kind":"Field","name":{"kind":"Name","value":"recipientEmail"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"cents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtotalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliverAt"}}]}}]}}]} as unknown as DocumentNode<ConfirmAccessGiftMutation, ConfirmAccessGiftMutationVariables>;
export const UserRewardsLevelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userRewardsLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userRewards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"level"}}]}}]}}]} as unknown as DocumentNode<UserRewardsLevelQuery, UserRewardsLevelQueryVariables>;
export const GetRedemptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRedemption"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"gift"},"name":{"kind":"Name","value":"accessGiftPurchaseByRedemptionCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"redemptionCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redemptionCode"}},{"kind":"Field","alias":{"kind":"Name","value":"product"},"name":{"kind":"Name","value":"troonCardSubscriptionProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GiftProduct"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GiftProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TroonCardSubscriptionProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"valueProps"}},{"kind":"Field","name":{"kind":"Name","value":"autoRenew"}},{"kind":"Field","name":{"kind":"Name","value":"disclosure"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<GetRedemptionQuery, GetRedemptionQueryVariables>;
export const SetupTroonCardSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"setupTroonCardSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"promoCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"utm"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UTMAttributesInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"subscription"},"name":{"kind":"Name","value":"setupTroonCardSubscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"troonCardSubscriptionProductId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}},{"kind":"Argument","name":{"kind":"Name","value":"promoCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"promoCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"utmAttributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"utm"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripeClientSecret"}},{"kind":"Field","name":{"kind":"Name","value":"stripeCustomerId"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionName"}},{"kind":"Field","name":{"kind":"Name","value":"troonCardSubscriptionId"}},{"kind":"Field","name":{"kind":"Name","value":"stripeClientSecretIntentType"}},{"kind":"Field","name":{"kind":"Name","value":"promoCode"}},{"kind":"Field","name":{"kind":"Name","value":"disclosure"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"cents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtotalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<SetupTroonCardSubscriptionMutation, SetupTroonCardSubscriptionMutationVariables>;
export const ReservationInviteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"reservationInvite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reservationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shareInviteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invite"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reservation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reservationId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invite"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShareReservation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reservationInvite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reservationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reservationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"shareInviteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareInviteId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invite"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShareReservation"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShareReservation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Reservation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"holeCount"}},{"kind":"Field","name":{"kind":"Name","value":"includesCart"}},{"kind":"Field","name":{"kind":"Name","value":"playerCount"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dayTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"day"}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hour"}},{"kind":"Field","name":{"kind":"Name","value":"minute"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ReservationInviteQuery, ReservationInviteQueryVariables>;
export const JoinReservationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"joinReservation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reservationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shareInviteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"joinReservation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reservationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reservationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"shareInviteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareInviteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<JoinReservationMutation, JoinReservationMutationVariables>;
export const AcceptReservationInviteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"acceptReservationInvite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reservationUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptReservationInvite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reservationUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reservationUserId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AcceptReservationInviteMutation, AcceptReservationInviteMutationVariables>;
export const RejectReservationInviteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"rejectReservationInvite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reservationUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rejectReservationInvite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reservationUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reservationUserId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<RejectReservationInviteMutation, RejectReservationInviteMutationVariables>;
export const ReservationInformationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"reservationInformation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"accessUpsell"},"name":{"kind":"Name","value":"troonAccessReservationUpsell"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reservationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayValue"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"guestPasses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pending"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accepted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"activeTroonCardSubscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productAddOns"}}]}}]}}]} as unknown as DocumentNode<ReservationInformationQuery, ReservationInformationQueryVariables>;
export const CancelReservationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"cancelReservation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelReservation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CancelReservationMutation, CancelReservationMutationVariables>;
export const LeaveReservationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"leaveReservation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reservationUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leaveReservation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reservationUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reservationUserId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<LeaveReservationMutation, LeaveReservationMutationVariables>;
export const AddGuestPassToUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addGuestPassToUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reservationUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addGuestPassToUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reservationUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reservationUserId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AddGuestPassToUserMutation, AddGuestPassToUserMutationVariables>;
export const SuggestedReservationUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"suggestedReservationUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reservationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suggestedReservationUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reservationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reservationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"troonAccessProductType"}}]}}]}}]} as unknown as DocumentNode<SuggestedReservationUsersQuery, SuggestedReservationUsersQueryVariables>;
export const InviteUserToReservationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"inviteUserToReservation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reservationUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inviteUserToReservation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reservationUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reservationUserId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InviteUserToReservationMutation, InviteUserToReservationMutationVariables>;
export const RemoveUserFromReservationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeUserFromReservation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reservationUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeUserFromReservation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reservationUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reservationUserId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveUserFromReservationMutation, RemoveUserFromReservationMutationVariables>;
export const DeactivateGuestPassDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deactivateGuestPass"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"guestPassId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deactivateGuestPass"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"guestPassId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"guestPassId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reservation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeactivateGuestPassMutation, DeactivateGuestPassMutationVariables>;